import JsFileDownloader from 'js-file-downloader';

export default {
	methods: {
		getVoteResults(poll, visualisationType) {
			return this.get('/manager/vote-results', {
				poll: poll,
				type: visualisationType
			}).then((data) => {
				return data.votes;
			});
		},
		loadManagerData() {
			return this.get('/manager/load-data');
		},
		end() {
			return this.post('/manager/end');
		},
		export(pollId) {
			return this.get('/manager/export', { pollId: pollId }).then((contents) => {

				return contents.url;
			});
		},
		setActivePoll(poll) {
			return this.post('/manager/set-active-poll', {
				poll: poll
			});
		},
		setAcceptAnswers(acceptAnswers) {
			return this.post('/manager/set-accept-answers', {
				acceptAnswers: acceptAnswers
			});
		},
		verifyManagerCode(uid) {
			return this.post('/manager/verify-manager-code', {uid: uid}).then((data) => {
				return true;
			});
		},
		setVisualisationEnabled(visualisationEnabled) {
			return this.post('/manager/set-visualisation-enabled', {
				visualisationEnabled: visualisationEnabled
			});
		},
		setVisualisationType(visualisationType) {
			return this.post('/manager/set-visualisation-type', {
				visualisationType: visualisationType
			});
		},
	}
}
